import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  searchTerm: '',
  filterModel: {},
  columnState: [],
}

export const ntierDashboardSlice = createSlice({
  name: 'ntierDashboard',
  initialState,
  reducers: {
    setNtierSearchTerm: (state, action) => {
      state.searchTerm = action.payload
    },
    setNtierDashboardFilterModel: (state, action) => {
      state.filterModel = action.payload
    },
    setNtierDashboardColumnState: (state, action) => {
      state.columnState = action.payload
    },
    resetNtierDashboardFilters: (state) => {
      state.searchTerm = ''
      state.filterModel = {}
      state.columnState = []
    },
  },
})

export const {
  setNtierSearchTerm,
  setNtierDashboardFilterModel,
  setNtierDashboardColumnState,
  resetNtierDashboardFilters,
} = ntierDashboardSlice.actions

export default ntierDashboardSlice.reducer
